export const SUPPLIER_LIST_REQUEST = "SUPPLIER_LIST_REQUEST";
export const SUPPLIER_LIST_SUCCESS = "SUPPLIER_LIST_SUCCESS";
export const SUPPLIER_LIST_FAIL = "SUPPLIER_LIST_FAIL";
export const SUPPLIER_LIST_RESET = "SUPPLIER_LIST_RESET";

export const SUPPLIER_SINGLE_REQUEST = "SUPPLIER_SINGLE_REQUEST";
export const SUPPLIER_SINGLE_SUCCESS = "SUPPLIER_SINGLE_SUCCESS";
export const SUPPLIER_SINGLE_FAIL = "SUPPLIER_SINGLE_FAIL";
export const SUPPLIER_SINGLE_RESET = "SUPPLIER_SINGLE_RESET";

export const POST_SUPPLIER_REQUEST = "POST_SUPPLIER_REQUEST";
export const POST_SUPPLIER_SUCCESS = "POST_SUPPLIER_SUCCESS";
export const POST_SUPPLIER_FAIL = "POST_SUPPLIER_FAIL";
export const POST_SUPPLIER_RESET = "POST_SUPPLIER_RESET";

export const UPDATE_SUPPLIER_REQUEST = "UPDATE_SUPPLIER_REQUEST";
export const UPDATE_SUPPLIER_SUCCESS = "UPDATE_SUPPLIER_SUCCESS";
export const UPDATE_SUPPLIER_FAIL = "UPDATE_SUPPLIER_FAIL";
export const UPDATE_SUPPLIER_RESET = "UPDATE_SUPPLIER_RESET";

export const DELETE_SUPPLIER_REQUEST = "DELETE_SUPPLIER_REQUEST";
export const DELETE_SUPPLIER_SUCCESS = "DELETE_SUPPLIER_SUCCESS";
export const DELETE_SUPPLIER_FAIL = "DELETE_SUPPLIER_FAIL";
export const DELETE_SUPPLIER_RESET = "DELETE_SUPPLIER_RESET";
